export const BREADCRUMBS_SLICE = 'BREADCRUMBS_SLICE';

export const BreadcrumbsSections = {
    MAIN_PAGE: 'Главная страница',
    REPORTS: 'Отчеты',
    REPORT: 'Отчет',
};
